import {
  getOrderList,
  submitOrder,
  refund,
  otherVendorRecharge,
  exportOrderList,
  getOrderCount,
  batchSubmitVendor,
} from "@/api/order";
import Pagination from "@/components/Pagination";
import Search from "@/components/Search";
let _this;
export default {
  name: "framework",
  components: {
    Pagination,
    Search,
  },
  data() {
    return {
      orderObj: {
        list: [],
        total: 0,
        listLoading: false,
      },
      form: {
        pageNum: 1,
        pageSize: 10,
        orderType: 6,
        adminOrderStatus: "",
        orderStatus: "",
        createTimeStartYMDStr: "",
        createTimeEndYMDStr: "",

        orderNo: "",
        chargeAccount: "",
        userTelnoLike: "",
        sharerTelnoLike: "",
        orderSharerType: "",
      },
      payDate: "",
      //订单统计
      orderCount: {
        orderAmountSum: 0,
        orderNum: 0,
        platformProfit: 0,
        shareProfit: 0,
        successAmountSum: 0,
      },
      //提交
      submitObj: {
        dialogTitle: "共提交",
        showDialog: false,
        dialogLoading: false,
        form: {
          orderId: undefined,
          orderNo: undefined,
          amount: undefined,
        },
      },
      //退款
      refundObj: {
        dialogTitle: "退款",
        showDialog: false,
        dialogLoading: false,
        form: {
          orderId: undefined,
          successAmount: undefined,
          refundAmount: undefined,
          remark: undefined,
        },
      },
      //其他渠道完成情况
      channelObj: {
        dialogTitle: "其他渠道完成情况",
        showDialog: false,
        dialogLoading: false,
        form: {
          orderId: undefined,
          isAllSuccess: 1,
          remark: undefined,
        },
      },
      submitIds: [],
      dialogLoadingSubmit: false,
      orderRemarkObj: {
        dialogTitle: "备注",
        showDialog: false,
        dialogLoading: false,
        form: {
          orderId: undefined,
          remark: undefined,
        },
      },
    };
  },
  beforeCreate() {
    _this = this;
  },
  filters: {
    rechargeChannelFilter(type) {
      //充值渠道
      return _this.$constant.RECHARGE_CHANNEL[type];
    },
    OrderStatusFilter(type) {
      //订单状态
      return _this.$constant.ORDER_STATUS[type];
    },
    SubmitStatus(type) {
      //账户状态
      return _this.$constant.SUBMIT_STATUS[type];
    },
    StatusType(type) {
      //账户状态
      return _this.$constant.STATUS_TYPE[type];
    },
  },
  created() {
    this.getOrderPage();
  },
  watch: {
    // 如果路由发生变化，再次执行该方法
    $route: "getOrderPage",
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name == "all") {
        this.form.orderStatus = "";
      } else {
        this.form.orderStatus = tab.name;
      }
    },
    SelectionChange(row) {
      let _this = this;
      if (row.length > 0) {
        _this.submitIds = [];
        row.forEach((item, index) => {
          _this.submitIds.push(item.id);
        });
      } else {
        _this.submitIds = [];
      }
    },
    allSubmit() {
      if (this.submitIds.length == 0) {
        this.$message.error("请选择提交订单");
        return;
      }
      if (this.dialogLoadingSubmit == true) {
        return;
      }
      this.dialogLoadingSubmit = true;
      let _this = this;
      _this.$throttle.canDoFunction({
        key: "allSubmit",
        time: 2000,
        success: () => {
          batchSubmitVendor({ orderIdList: _this.submitIds }).then((res) => {
            if(res.code == 200){
              _this.$message.success('提交成功1');
            }else{
              _this.$message.error(res.message);
            }
            _this.dialogLoadingSubmit = false;
            setTimeout(function () {
              location.reload();
            }, 1000);
          });
        },
      });
    },
    //获取订单列表
    getOrderPage(type) {
      if (type == 1) {
        _this.form.pageNum = 1;
      }
      if (this.payDate != "") {
        _this.form.createTimeStartYMDStr = this.payDate[0];
        _this.form.createTimeEndYMDStr = this.payDate[1];
      }
      _this.orderObj.listLoading = true;
      //获取订单列表
      getOrderList(_this.form).then((res) => {
        _this.orderObj.list = res.data.list;
        _this.orderObj.total = res.data.total;
        _this.orderObj.listLoading = false;
      });
      //获取订单统计
      getOrderCount({ orderType: this.form.orderType }).then((res) => {
        if (res.code == 200) {
          _this.orderCount = res.data;
        }
      });
    },
    onRefund(i) {
      this.refundObj.showDialog = true;
      this.refundObj.form.orderId = this.orderObj.list[i].id;
      this.refundObj.form.successAmount = this.orderObj.list[i].realPayAmount;
      this.refundObj.form.refundAmount = this.orderObj.list[i].refundAmount;
    },
    checkRefundMoney() {
      // if(this.refundObj.form.refundAmount > this.refundObj.form.successAmount){
      // 	this.refundObj.form.refundAmount = this.refundObj.form.successAmount
      // }
    },
    //退款
    refund(i) {
      this.refundObj.showDialog = false;
      refund(this.refundObj.form).then((res) => {
        if (res.code == 200) {
          _this.$message.success("提交成功");
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    onChannel(i) {
      this.channelObj.showDialog = true;
      this.channelObj.form.orderId = this.orderObj.list[i].id;
      this.channelObj.form.isAllSuccess = 1;
    },
    // 其他渠道
    otherVendorRecharge(i) {
      this.channelObj.showDialog = false;
      otherVendorRecharge(this.channelObj.form).then((res) => {
        if (res.code == 200) {
          _this.$message.success("提交成功");
          _this.refresh();
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    refresh() {
      setTimeout(function () {
        this.created();
      }, 2000);
    },
    //跳转详情
    gotoDetail(id) {
      _this.$router.push("detail?id=" + id);
    },
    //导出订单列表
    exportList() {
      let loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      exportOrderList({ orderType: this.form.orderType })
        .then((res) => {
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    onSubmit(i) {
      this.submitObj.showDialog = true;
      this.submitObj.form.orderId = this.orderObj.list[i].id;
      this.submitObj.form.orderNo = this.orderObj.list[i].orderNo;
      this.submitObj.form.amount = this.orderObj.list[i].realPayAmount;
    },
    //提交订单
    submitOrder(i) {
      let _this = this;
      _this.submitObj.showDialog = false;
      submitOrder({ orderId: this.submitObj.form.orderId }).then((res) => {
        if (res.data.isSuccess == true) {
          _this.$message.success("提交成功");
        } else {
          _this.$message.error(res.data.failReason);
        }
      });
    },
  },
};
